import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import ArrowBackIcon from '@/assets/images/icons/west.svg';
import AdminPage from '@/components/AdminContent/AdminPage';
import NavBar from '@/components/NavBar/NavBar';
import { useAppSelector } from '@/hooks/redux-hooks';
import ConfirmPopup from '@/uikit/popups/examples/ConfirmPopup/ConfirmPopup';

import styles from './styles.module.scss';

const Admin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const canGoBack = location.key !== 'default';
  const { t } = useTranslation();

  const {
    url,
    isUnsafeBack,
  } = useAppSelector((state) => state.historyReducer);

  const [isConfirmPopupOpen, setIsConfirmPopupOpen] = useState(false);

  const historyBack = () => {
    if (canGoBack) {
      navigate(-1);
      return;
    }
    navigate(url);
  };

  const clickBackButton = () => {
    if (isUnsafeBack) {
      setIsConfirmPopupOpen(true);
    } else {
      historyBack();
    }
  };

  return (
    <div className={styles.layout}>
      <NavBar />
      <main>
        {url && (
          <div className={styles.back} onClick={clickBackButton}>
            <ArrowBackIcon />
            {t('button.back')}
          </div>
        )}
        <div className={styles.container}>
          <AdminPage>
            <Outlet />
          </AdminPage>
        </div>
      </main>
      <ConfirmPopup
        isOpen={isConfirmPopupOpen}
        closeHandler={() => setIsConfirmPopupOpen(false)}
        acceptHandler={historyBack}
      >
        {t('common.lost_changes_message')}
      </ConfirmPopup>
    </div>
  );
};

export default Admin;
